import List from '@mui/material/List';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useLocalization } from '@/shared/hooks/useLocalization';
import { MenuConfigItem } from '@/shared/interfaces/side-menu-item.interface';
import { RootState } from '@/shared/redux/reducers';
import { getMenuList } from '@/shared/services/routes/routes.service';

import MenuItem from './menu-item';

interface SideMenuContentProps {
  isCollapsed: boolean;
}

const SideMenuContent = ({ isCollapsed }: SideMenuContentProps) => {
  const { t, isRTLDirect: isRTL } = useLocalization();
  const [MenuItems, setMenuItems] = useState<MenuConfigItem[]>([]);
  const userRole = useSelector((state: RootState) => state.auth.role);
  const userTeam = useSelector((state: RootState) => state.auth.team);

  useEffect(() => {
    const MenuItemsList = getMenuList(userRole, userTeam, t);
    setMenuItems(MenuItemsList);
  }, [t]);

  return (
    <List
      component="nav"
      sx={{
        p: '0px 10px',
        pt: { xs: '7rem' },
        width: isCollapsed ? '64px' : '256px',
        transition: 'width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
        overflowX: 'hidden',
        direction: isRTL ? 'rtl' : 'ltr'
      }}
    >
      {MenuItems.map((item, key) => {
        return <MenuItem item={item} key={key} isCollapsed={isCollapsed} />;
      })}
    </List>
  );
};

export default SideMenuContent;
